(function () {
    const interactiveSections = document.querySelectorAll('.section__interaction');

    function handleInteractions(entries) {

        entries.forEach(function(entry){

            const element = entry.target;
            
            if (entry.isIntersecting) {
                element.classList.add('interacting');
                interactionObserver.unobserve(element);
            }          

        });

    }

    const options = {
        threshold: 0.5,
    };

    var interactionObserver = new IntersectionObserver(handleInteractions, options);

    interactiveSections.forEach(function(elem){
        interactionObserver.observe(elem);
    });

})();